const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const hoverQuery = window.matchMedia('(any-hover: hover) and (pointer: fine)');
const activeCards = new WeakMap();

function canTilt(event) {
  return !reducedMotionQuery.matches && hoverQuery.matches && event.pointerType !== 'touch';
}

function resetCard(card) {
  const frame = activeCards.get(card);
  if (frame) window.cancelAnimationFrame(frame);
  activeCards.delete(card);
  card.classList.remove('daaman-card-motion-active');
  card.style.removeProperty('--daaman-card-rotate-x');
  card.style.removeProperty('--daaman-card-rotate-y');
  card.style.removeProperty('--daaman-card-glow-x');
  card.style.removeProperty('--daaman-card-glow-y');
}

function updateCard(card, event) {
  if (!canTilt(event)) return;

  const rect = card.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  const x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
  const y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);

  const frame = window.requestAnimationFrame(() => {
    card.classList.add('daaman-card-motion-active');
    card.style.setProperty('--daaman-card-rotate-y', `${(x - 0.5) * 7}deg`);
    card.style.setProperty('--daaman-card-rotate-x', `${(0.5 - y) * 5}deg`);
    card.style.setProperty('--daaman-card-glow-x', `${x * 100}%`);
    card.style.setProperty('--daaman-card-glow-y', `${y * 100}%`);
    activeCards.delete(card);
  });

  const previousFrame = activeCards.get(card);
  if (previousFrame) window.cancelAnimationFrame(previousFrame);
  activeCards.set(card, frame);
}

document.addEventListener(
  'pointermove',
  (event) => {
    const card = event.target.closest?.('.product-card, .daaman-product-tile');
    if (!card) return;
    updateCard(card, event);
  },
  { passive: true }
);

document.addEventListener(
  'pointerout',
  (event) => {
    const card = event.target.closest?.('.product-card, .daaman-product-tile');
    if (card?.contains(event.relatedTarget)) return;
    if (card) resetCard(card);
  },
  { passive: true }
);

document.addEventListener('pointercancel', (event) => {
  const card = event.target.closest?.('.product-card, .daaman-product-tile');
  if (card) resetCard(card);
});

document.addEventListener('focusout', (event) => {
  const card = event.target.closest?.('.product-card, .daaman-product-tile');
  if (card && !card.contains(event.relatedTarget)) resetCard(card);
});

reducedMotionQuery.addEventListener?.('change', () => {
  document.querySelectorAll('.product-card.daaman-card-motion-active, .daaman-product-tile.daaman-card-motion-active').forEach(resetCard);
});
